var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlisveris(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#2B87BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 7.7h1.125c.619 0 1.125.495 1.125 1.1v6.6c0 .605-.506 1.1-1.125 1.1h-6.75c-.619 0-1.125-.495-1.125-1.1V8.8c0-.605.506-1.1 1.125-1.1H8.75c0-1.216 1.007-2.2 2.25-2.2s2.25.984 2.25 2.2zm-3.938 2.75c.31 0 .563-.247.563-.55V8.8H8.75v1.1c0 .303.253.55.563.55zM11 6.6c.619 0 1.125.495 1.125 1.1h-2.25c0-.605.506-1.1 1.125-1.1zm1.688 3.85c.309 0 .562-.247.562-.55V8.8h-1.125v1.1c0 .303.253.55.563.55z",
    fill: "#fff"
  })));
}
export default SvgAlisveris;